<template>

<div class="loader" role="status" aria-label="Loading">

	<span class="loader-mark" :style="frameStyle">
		<span class="loader-grid" :style="gridStyle">
			<span class="loader-tile loader-t0"></span>
			<span class="loader-tile loader-t1"></span>
			<span class="loader-tile loader-t2"></span>
			<span class="loader-tile loader-t3"></span>
		</span>
	</span>

</div>

</template>

<script>

/*
	The loading state: the whatboxart mark with its four tiles cycling colour in
	a staggered ripple (ink / neutral / accent) — a tiled cover shuffling over
	hidden box art. Scales off `size`. Reduced-motion holds the static checker.
*/

export default {

	props: {
		size: {
			default: 46
		}
	},

	computed: {

		s: function() {

			return Number(this.size) || 46

		},

		frameStyle: function() {

			var s = this.s

			return {
				width: s + 'px',
				height: s + 'px',
				borderRadius: (s * 0.158).toFixed(2) + 'px',
				border: Math.max(1.25, s * 0.04).toFixed(2) + 'px solid var(--ink)',
				padding: (s * 0.131).toFixed(2) + 'px'
			}

		},

		gridStyle: function() {

			return {
				gap: (this.s * 0.079).toFixed(2) + 'px'
			}

		}

	}

}

</script>

<style scoped>

.loader {
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 40px 0;
}

.loader-mark {
	display: inline-flex;
	box-sizing: border-box;
}

.loader-grid {
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-template-rows: 1fr 1fr;
	width: 100%;
	height: 100%;
}

.loader-tile {
	display: block;
	border-radius: 1.5px;
	background: #cfc6b4;
	animation: loader-cycle 1.4s ease-in-out infinite;
}

/* staggered around the 2x2 so the colour ripples through the tiles */
.loader-t0 { animation-delay: 0s; }
.loader-t1 { animation-delay: 0.35s; }
.loader-t3 { animation-delay: 0.7s; }
.loader-t2 { animation-delay: 1.05s; }

@keyframes loader-cycle {
	0%, 100% { background: #cfc6b4; }
	30% { background: #1c1a16; }
	60% { background: #3f5d8a; }
}

@media (prefers-reduced-motion: reduce) {

	.loader-tile {
		animation: none;
	}

	.loader-t0, .loader-t3 {
		background: #1c1a16;
	}

}

</style>
